module.exports = __webpack_public_path__ + "img/20200328134744502.06b5e61c.png";